module.exports = __webpack_public_path__ + "images/885e2287b07fa2abf89c8e9abfbe93a6.png";